import styled from 'styled-components';

import { Modal } from '@dexma/ui-components';

export const StyledPinDashboardModal = styled(Modal)`
    .buttons {
        margin-top: 30px;
        text-align: left;
        display: flex;
        justify-content: flex-end;
        .cancel {
            margin-left: 10px;
        }
        // Todo fix on the ui library
        svg,
        .StyledSpinner-iA-dccK {
            border-color: rgb(255 255 255) rgba(255, 255, 255, 0.1) rgba(255, 255, 255, 0.1);
            margin-right: 5px;
        }
    }
    .server-error-alert {
        margin-bottom: 20px;
    }
    .ant-modal-header {
        border-bottom: none;
    }
`;
